var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-8 mb-8",attrs:{"justify":"center"}},[_c('div',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"length":_vm.lastPage,"total-visible":8},on:{"next":function($event){_vm.page + 1},"previous":function($event){_vm.page - 1}},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }